<template>
    <div class="custom-radio-container flex-level jc-space">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {

        },
        data(){
            return {
            }
        },
    }
</script>

<style scoped>

</style>
